module.exports = __webpack_public_path__ + "static/media/dd974b32def51092dc7c45b87f8f192a.2174fea3.JPEG";